import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UserBasicInfo, userService } from "api/user";
import { getUserInfo } from "appredux/actions/showActions";
import { User } from "appredux/model/user";

interface UsersState {
  data: User;
  loading: "pending" | "succeeded" | "failed";
}

const initialState = {
  data: null,
  loading: "pending",
} satisfies UsersState as UsersState;

export const updateUserInfo = createAsyncThunk(
  "user/updateUserInfo",
  async (userInfo: UserBasicInfo) => {
    const response = await userService.updateUserBasicInfo(userInfo);
    return response;
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "succeeded";
    });

    builder.addCase(getUserInfo.pending, (state, action) => {
      state.loading = "pending";
    });

    builder.addCase(getUserInfo.rejected, (state, action) => {
      state.loading = "failed";
    });

    builder.addCase(updateUserInfo.rejected, (state, action) => {
      state.loading = "failed";
    });

    builder.addCase(updateUserInfo.fulfilled, (state, action) => {
      state.data.firstname = action.meta.arg.firstname;
      state.data.lastname = action.meta.arg.lastname;
      state.loading = "succeeded";
    });
  },
  selectors: {
    selectUserInfo: (state: UsersState) => state.data,
    selectUserInfoLoading: (state: UsersState) => state.loading,
  },
});

export const { selectUserInfo, selectUserInfoLoading } = usersSlice.selectors;
export default usersSlice.reducer;
